import urlJoin from "helpers/urljoin";
import Config from "config";
import axios from "axios";

export const shortlistInventoryAsync = async (shortlist_inv: any, user_auth_token: any) => {
  const options = {
    url_path: "/api/v0/auth/users/inventories_shortlists/",
    data: {
      inventories_shortlist: { inventory_id: shortlist_inv },
      ...(user_auth_token && { user_auth_token }),
    },
  };

  const url = urlJoin(Config.API_URL, options.url_path);

  try {
    const response = await axios.post(url, options.data, {
      headers: {
        Cookie: `user_auth_token=${user_auth_token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error shortlisting inventory:", error);
    throw error;
  }
};

const createInventoriesShortlist = async (options: any) => {
  options.url_path = options.url_path || "/api/v0/auth/users/inventories_shortlists";
  options.url = urlJoin(Config.API_URL, options.url_path);
  try {
    const res = await axios.post(options.url, { ...options.data }, { withCredentials: true });
    return res;
  } catch ({ response }: any) {
    const res: any = response;
    return { error: res?.data?.message?.user_friendly_message };
  }
};

export const deleteInventoriesShortlist = async (inventoryId: any, options: any) => {
  options.url_path = options.url_path || "/api/v0/auth/users/inventories_shortlists";
  options.url = urlJoin(Config.API_URL, options.url_path, `${inventoryId}`);
  try {
    const res = await axios.delete(options.url, {
      ...(options.data?.user_auth_token && {
        params: { user_auth_token: options.data?.user_auth_token },
      }),
      withCredentials: true,
    });
    return res;
  } catch ({ response }: any) {
    const res: any = response;
    return { error: res?.data?.message?.user_friendly_message };
  }
};

export const addShortlistParamInURL = (invId: any) => {
  const query = new URLSearchParams(window.location.search);
  query.set("shortlist_inv", invId);

  const newURL = `${window.location.origin}${window.location.pathname}?${query.toString()}`;
  window.history.replaceState({ ...window.history.state, path: newURL }, "", newURL);
};

export const removeShortlistParamFromURL = () => {
  const query = new URLSearchParams(window.location.search);
  const shortlistInv = query.get("shortlist_inv");
  if (shortlistInv) {
    query.delete("shortlist_inv");
    let newURL = `${window.location.origin}${window.location.pathname}`;
    const qString = query.toString();
    if (qString) {
      newURL = `${newURL}?${qString}`;
    }
    window.history.replaceState({ ...window.history.state, path: newURL }, "", newURL);
  }
};

export default createInventoriesShortlist;
